import React from 'react';
import { DayContext } from '../../entities/planResult';

interface Props {
  dayCount: number[];
  monthIndex: number;
  highlightDays?: DayContext[][];
  displayYear: number;
}

const BurnGraphBackground: React.FC<Props> = ({ dayCount, monthIndex, highlightDays, displayYear }) => {
  const totalDays = dayCount.reduce((sum, d) => sum + d, 0);
  const baseDate = new Date(displayYear, 3, 1);

  const toZeroTime = (date: Date | string) => {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
  };

  const individualHighlights: boolean[][] = [];

  if (highlightDays) {
    highlightDays.forEach((group) => {
      const highlight = new Array(totalDays).fill(false);

      group.forEach(({ shutdown_date, launch_date, not_change_flag }) => {
        if (!not_change_flag) return;

        const start = toZeroTime(shutdown_date);
        const end = toZeroTime(launch_date);

        if (isNaN(start.getTime()) || isNaN(end.getTime())) return;

        for (let i = 0; i < totalDays; i++) {
          const current = new Date(baseDate);
          current.setDate(baseDate.getDate() + i);
          const currentZero = toZeroTime(current);

          if (currentZero >= start && currentZero < end) {
            highlight[i] = true;
          }
        }
      });

      individualHighlights.push(highlight);
    });
  }

  const combinedHighlights = new Array(totalDays).fill(true);
  for (let i = 0; i < totalDays; i++) {
    combinedHighlights[i] = individualHighlights.every((hl) => hl[i] === true);
  }

  let displayHighlights = combinedHighlights;
  let displayDays = totalDays;
  if (monthIndex > 0) {
    const startIndex = dayCount.slice(0, monthIndex - 1).reduce((a, b) => a + b, 0);
    const length = dayCount[monthIndex - 1];
    displayHighlights = combinedHighlights.slice(startIndex, startIndex + length);
    displayDays = length;
  }

  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        height: '100%',
        width: '875px',
        display: 'flex',
        zIndex: 0,
        pointerEvents: 'none',
      }}
    >
      {displayHighlights.map((highlight, idx) => (
        <div
          key={idx}
          style={{
            width: `${100 / displayDays}%`,
            height: '100%',
            backgroundColor: highlight ? 'rgba(255, 0, 47, 0.2)' : 'transparent',
          }}
        />
      ))}
    </div>
  );
};

export default BurnGraphBackground;
